export const config = {
  apiKey: 'AIzaSyDVapZQ-PB2yH_PAIQaSmgUB1GaKu6PrM0',
  authDomain: 'lg-opu.firebaseapp.com',
  databaseURL: 'https://lg-opu.firebaseio.com',
  projectId: 'lg-opu',
  storageBucket: 'lg-opu.appspot.com',
  messagingSenderId: '233660475109',
  appId: '1:233660475109:web:5dac000dba5783424c160c',
  measurementId: 'G-3KK7392QK8'
}
